import Vue from 'vue'
import FavoriteStopsMixin from 'js/mixins/favorite-stops-mixin'
import {mapActions} from 'vuex'
import template from './_stop-card.pug'

// @vue/component
export default Vue.extend({
  name: 'stop-card',
  template: template(),

  mixins: [FavoriteStopsMixin],

  props: {
    stop: {
      type: Object,
      required: true
    },
    tabindex: {
      type: Number,
      default: 30
    },
    selectedStopId: {
      type: String,
      default: null, // Estado actual de selección
    }
  },

  computed: {
    stopId() {
      return `stop-${this.stop.id}`
    }
  },

  methods: {
    stopClick() {
      this.$emit('stop-click')
    },
    isValidLogoUrl(url) {
      if (!url) return false; // Comprueba si no es nulo o undefined
      try {
        new URL(url); // Intenta crear una URL
        return true; // Si no lanza un error, es válida
      } catch (err) {
        return false; // Si lanza un error, no es válida
      }
    }
  }
})
